import i18next from "i18next";

export const getMimeTypeLabel = (mimeType?: string): string => {
    if (!mimeType) return i18next.t("common.file_type.unknown", "Unknown");

    if (mimeType.startsWith("image/")) {
        return mimeType.split("/")[1].toUpperCase();
    }

    const mimeMap: Record<string, string> = {
        "application/pdf": "PDF",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
        "application/msword": "DOC",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
        "application/vnd.ms-excel": "XLS",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PPTX",
        "application/vnd.ms-powerpoint": "PPT",
        "text/plain": "TXT",
        "application/rtf": "RTF",
    };

    return (
        mimeMap[mimeType] ||
        mimeType.split("/").pop()?.toUpperCase() ||
        i18next.t("common.file_type.unknown", "Unknown")
    );
};

export const byteValueNumberFormatter = (value: number) =>
    Intl.NumberFormat(i18next.language, {
        notation: "compact",
        style: "unit",
        unit: "byte",
        unitDisplay: "narrow",
    }).format(value);
